"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const axios_1 = __importDefault(require("axios"));
const vue_property_decorator_1 = require("vue-property-decorator");
let BuscadorFiltro = class BuscadorFiltro extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.codigo = null;
        this.nombre = null;
        this.error = false;
        this.loading = false;
        this.resultados = [];
    }
    submit(e) {
        e.preventDefault();
        this.buscar();
    }
    buscar() {
        this.error = false;
        this.loading = true;
        this.resultados = [];
        axios_1.default
            .get("/api/inmuebles/resultados", { params: { codigo: this.codigo, nombre: this.nombre } })
            .then(response => {
            this.paginado = response.data.meta;
            this.resultados = response.data.data;
            this.procesar();
        })
            .catch(error => {
            this.$bvToast.toast(error, { title: `Error`, variant: `danger`, solid: true });
        })
            .finally(() => {
            this.loading = false;
        });
    }
    get total() {
        return this.resultados.length;
    }
    procesar() {
        if (this.total) {
            if (this.total === 1) {
                const resultado = lodash_1.default.head(this.resultados);
                if (resultado) {
                    return window.location = resultado.url;
                }
            }
            else {
                this.$bvModal.show("buscador_resultados");
            }
        }
        else {
            this.error = true;
        }
    }
};
BuscadorFiltro = __decorate([
    vue_property_decorator_1.Component({})
], BuscadorFiltro);
exports.default = BuscadorFiltro;
